import { render, staticRenderFns } from "./EstoqueSolicitacao.vue?vue&type=template&id=4378df57&scoped=true&"
import script from "./EstoqueSolicitacao.vue?vue&type=script&lang=js&"
export * from "./EstoqueSolicitacao.vue?vue&type=script&lang=js&"
import style0 from "./EstoqueSolicitacao.vue?vue&type=style&index=0&id=4378df57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4378df57",
  null
  
)

export default component.exports